<template>
  <el-main class="materialwrap">
    <div class="mybread">
      <p><i class="el-icon-location"></i>当前位置：</p>
      <el-breadcrumb separator-class="el-icon-arrow-right" v-if="mType == '1'">
        <el-breadcrumb-item>客户项目</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/purchase' }">供应商合同管理</el-breadcrumb-item>
        <el-breadcrumb-item>供应商合同详情</el-breadcrumb-item>
      </el-breadcrumb>
      <el-breadcrumb separator-class="el-icon-arrow-right" v-else>
        <el-breadcrumb-item>{{ mType == '2' ? '行政采购项目' : '人力资源项目' }}</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: mType == '2' ? '/adPurchase' : '/hrPurchase' }">供应商合同管理</el-breadcrumb-item>
        <el-breadcrumb-item>供应商合同详情</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="base1">
      <h3 class="ntitle">供应商信息</h3>
      <ul>
        <li>
          <p v-if="form.vendor_type == 1">
            <label>供应商名称：</label><a>{{ form.vendor }}</a>
          </p>
          <p>
            <label>供应商类型：</label><a>{{ form.vendor_type == 1 ? '公司' : '个人' }}</a>
          </p>
          <p>
            <label>{{ form.vendor_type == 1 ? '联系人姓名' : '姓名' }}：</label><a>{{ form.name }}</a>
          </p>
          <p>
            <label>{{ form.vendor_type == 1 ? '公司地址' : '住址' }}：</label><a>{{ form.vendor_type == 1 ? form.work_address :
              form.family_address }}</a>
          </p>
        </li>
        <li>
          <p>
            <label>联系人电话：</label><a>{{ form.phone }}</a>
          </p>
          <p>
            <label>联系人邮箱：</label><a>{{ form.email }}</a>
          </p>
        </li>
      </ul>
    </div>

    <div class="base1">
      <h3 class="ntitle">付款信息</h3>
      <ul>
        <li>
          <p>
            <label>付款账户：</label><a>{{ form.payee_name }}</a>
          </p>
          <p>
            <label>银行名称：</label><a>{{ form.payee_bank }}</a>
          </p>
          <p>
            <label>银行账号：</label><a class="hoverlink" @click="clickCopy(form.payee_bank_account)">{{
              form.payee_bank_account }}</a>
          </p>
        </li>
        <li></li>
      </ul>
    </div>

    <div class="base1" v-if="form.vendor_type == 1">
      <h3 class="ntitle">工商信息</h3>
      <ul>
        <li>
          <p>
            <label>统一社会信用代码：</label><a>{{ form.company_id_card }}</a>
          </p>
          <p>
            <label>公司注册地址：</label><a>{{ form.reg_address }}</a>
          </p>
          <p>
            <label>公司电话：</label><a>{{ form.company_phone }}</a>
          </p>
        </li>
        <li></li>
      </ul>
    </div>

    <div class="base1">
      <h3 class="ntitle">供应商合同信息</h3>
      <div class="operater">
        <div class="linkbox" @click="contractApply" :class="{ 'grey': (is_apply != 1 && is_apply != 3) }"
          v-if="mType == '1' ? NodeInclude('91') : (mType == '2' ? NodeInclude('147') : NodeInclude('175'))">
          {{ fileList1[0].origin_name ? '已签约' : (form.contract_no && form.contract_no != 'TBD' ? '已获取合同编号' : ((is_apply == 1 || is_apply == 3) ? '合同申请' : '等待编号')) }}
        </div>
      </div>
      <ul>
        <li>
          <p>
            <label>供应商合同编号：</label>
            <a style="width: 100%;">
              <el-col :span="10">
                {{ form.contract_no ? form.contract_no : '暂无合同编号' }}
              </el-col>
              <div class="projectArrBtnArea">
                <div class="projectArrBtn">
                  <el-button round style="text-align: center;" @click="getPurchaseNo" :disabled="!canGetNo" v-if="mType == '1' ? NodeInclude('92') : (mType == '2' ? NodeInclude('148') : NodeInclude('174'))">自动获取</el-button>
                </div>
                <div class="projectArrBtn" v-if="is_apply == 2 && !(form.contract_no && form.contract_no != 'TBD')">
                  <el-button round type="warning" style="text-align: center;" @click="handleConApply(3)" :disabled="!canGetNo" v-if="mType == '1' ? NodeInclude('92') : (mType == '2' ? NodeInclude('148') : NodeInclude('174'))">退回申请</el-button>
                </div>
              </div>
            </a>
          </p>
          <p>
            <label>供应商合同名称：</label><a>{{ form.contract_name }}</a>
          </p>
          <p>
            <label>供应商合同时间：</label><a>{{ form.contract_start_time + '-' + form.contract_end_time }}</a>
          </p>
          <p v-if="form.contract_type != 2">
            <label>供应商合同金额：</label><a>{{ form.contract_amount }}</a>
          </p>
          <p v-if="form.contract_type != 2">
            <label>税率：</label><a>{{ form.tax_rate + '%' }}</a>
          </p>
          <p>
            <label>备注：</label><a>{{ form.info }}</a>
          </p>
          <p style="width: 150%;">
            <label>电子合同附件：</label>
            <template>
              <ul class="anlist">
                <li v-for="(item, index) in fileList" :key="index">
                  <div class="abox">
                    <!-- 选择文件 -->
                    <el-col :span="4"
                      v-if="mType == '1' ? NodeInclude('254') : (mType == '2' ? NodeInclude('282') : NodeInclude('304'))">
                      <el-upload class="upload-demo" ref="upFile" action="#" :limit="1" :show-file-list="false"
                        :auto-upload="false" accept=".pdf, .doc, .docx, .xls, .xlsx, .jpg, .png" :file-list="item.flist"
                        :on-change="(arg) => uploadFile(arg, 'fileList', 'upFile', item, index)">
                        <el-button size="small" style="width: 80px;">选择文件</el-button>
                      </el-upload>
                    </el-col>
                    <!-- 文件预览及下载 -->
                    <template v-if="item.origin_name">
                      <el-col :span="20">
                        <el-col :span="18">
                          <div class="origin-name">{{ item.origin_name }}</div>
                        </el-col>
                        <el-col :span="2">
                          <el-link type="primary" style="margin-right:5px" :href="item.httpFile"
                            target="_blank">查看</el-link>
                        </el-col>
                      </el-col>
                    </template>
                  </div>
                  <el-button class="abtn"
                    v-if="(index === 0 && (mType == '1' ? NodeInclude('254') : (mType == '2' ? NodeInclude('282') : NodeInclude('304'))))"
                    icon="el-icon-plus" @click="addImage(fileList)" circle></el-button>
                  <el-button class="abtn"
                    v-if="(index > 0 && (mType == '1' ? NodeInclude('254') : (mType == '2' ? NodeInclude('282') : NodeInclude('304'))))"
                    icon="el-icon-minus" @click="removeImage(fileList, index)" circle></el-button>
                </li>
              </ul>
            </template>
          </p>
          <p style="width: 150%;">
            <label>盖章合同附件：</label>
            <template>
              <ul class="anlist">
                <li v-for="(item, index) in fileList1" :key="index">
                  <div class="abox">
                    <!-- 选择文件 -->
                    <el-col :span="4"
                      v-if="(form.contract_no && form.contract_no != 'TBD') && (mType == '1' ? NodeInclude('93') : (mType == '2' ? NodeInclude('149') : NodeInclude('173')))">
                      <el-upload class="upload-demo" ref="upFile1" action="#" :limit="1" :show-file-list="false"
                        :auto-upload="false" accept=".pdf, .doc, .docx, .xls, .xlsx, .jpg, .png" :file-list="item.flist"
                        :on-change="(arg) => uploadFile(arg, 'fileList1', 'upFile1', item, index)">
                        <el-button size="small" style="width: 80px;">选择文件</el-button>
                      </el-upload>
                    </el-col>
                    <el-col :span="4" v-else>
                      <el-button size="small" style="width: 80px;" @click="showWrongFn">选择文件</el-button>
                    </el-col>
                    <!-- 文件预览及下载 -->
                    <template v-if="item.origin_name">
                      <el-col :span="20">
                        <el-col :span="18">
                          <div class="origin-name">{{
                            item.origin_name }}</div>
                        </el-col>
                        <el-col :span="2">
                          <el-link type="primary" style="margin-right:5px" :href="item.httpFile"
                            target="_blank">查看</el-link>
                        </el-col>
                      </el-col>
                    </template>
                  </div>
                  <el-button class="abtn"
                    v-if="(index === 0) && (mType == '1' ? NodeInclude('93') : (mType == '2' ? NodeInclude('149') : NodeInclude('173')))"
                    icon="el-icon-plus" @click="addImage1(fileList1)" circle></el-button>
                  <el-button class="abtn"
                    v-if="index > 0 && (mType == '1' ? NodeInclude('93') : (mType == '2' ? NodeInclude('149') : NodeInclude('173')))"
                    icon="el-icon-minus" @click="removeImage1(fileList1, index)" circle></el-button>
                </li>
              </ul>
            </template>
          </p>
          <p>
            <label></label>
            <a>
              <el-button type="primary" @click="updateFn" style="margin-top: 18px;">确定上传</el-button>
            </a>
          </p>
        </li>
        <li>
          <p></p>
          <p>
            <label>合同类型：</label><a>{{ dd.contract_type[form.contract_type] }}</a>
          </p>
          <p>
            <label v-if="form.contract_type == 3">所属合同：</label><a v-if="form.contract_type == 3">{{
              (form.parentContractArr.contract_no ? form.parentContractArr.contract_no : '暂无') }}</a>
          </p>
          <p>
            <label>创建合同时间：</label><a>{{ form.create_time }}</a>
          </p>
          <p></p>
          <p v-if="form.contract_type != 2">
            <label>税额：</label><a>{{ form.tax }}</a>
          </p>
        </li>
      </ul>
    </div>

    <div class="base1" v-if="form.contract_type != '2'">
      <h3 class="ntitle">{{ mType == '2' || mType == '3' ? '项目信息' : '客户信息' }}</h3>
      <ul>
        <li>
          <p v-if="mType != '2' && mType != '3'">
            <label>客户名称：</label><a>{{ form.projectArr.client_company }}</a>
          </p>
          <p v-if="mType != '2' && mType != '3'">
            <label>品牌：</label><a>{{ form.projectArr.brand }}</a>
          </p>
          <p>
            <label>{{ (mType == '2' || mType == '3') ? '项目编号' : '客户合同编号' }}:</label>
            <a class="linkwrap normal"
              @click="link(mType == '2' || mType == '3' ? `/admin/view?id=${form.projectArr.id}&mType=${mType}` : `/project/detail?id=${form.projectArr.id}&mType=1`)">
              <el-link>
                {{ form.projectArr.contract_no }}
              </el-link>
            </a>
          </p>
          <p>
            <label>项目名称：</label><a>{{ form.projectArr.contract_name }}</a>
          </p>
          <p>
            <label>项目负责人：</label><a>{{ form.projectArr.manager_name }} {{ form.projectArr.manager_enname }}</a>
          </p>
        </li>
        <li></li>
      </ul>
    </div>

    <el-dialog title="合同申请" :visible.sync="conShow" :close-on-click-modal="false" :show-close="false" width="500px">
      <ul class="aul" style="padding:0">
        <li>
          <span>请确认是否进行合同申请？</span>
          <span style="display: inline-block; font-size: 12px; margin-top: 20px; color: red;">!!合同申请前请再次确认合同金额是否正确，一旦获取合同编号，金额就不能再增加！</span>
        </li>
      </ul>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleConApplyNo">取 消</el-button>
        <el-button type="primary" @click="handleConApply(2)" :disabled="isDisabled">{{ buttonWord }}</el-button>
      </span>
    </el-dialog>
  </el-main>
</template>

<script>
import * as api from '@/api'
import store from '@/store'
import { antiThousands } from '@/utils/index.js'
export default {
  name: 'vendordetail',
  data() {
    return {
      nodeLimtList: [],
      mType: '1',
      is_apply: '',
      level: '',
      form: {
        client_id: '',
        client_company: '',
        brand: '',
        project_id: '',
        //供应商信息
        contract_id: '',
        vendor_id: '',
        vendor: '',
        vendor_type: '1',
        name: '',
        phone: '',
        email: '',
        payee_name: '',
        payee_bank: '',
        payee_bank_account: '',
        company_id_card: '',
        reg_address: '',
        company_phone: '',
        //合同信息
        contract_no: '',
        contract_type: '2',
        parent_project_id: '',
        contract_name: '',
        contract_start_time: '',
        contract_end_time: '',
        contract_amount: '',
        tax_rate: '0',
        tax: '',
        info: '',
        status: '',
        atta_str: [],//合同附件数组
        projectArr: {
          contract_type: '',
          parentContractNo: '',
        }
      },
      conShow: false,
      canGetNo: true,
      fileList: [
        { origin_name: '', file_name: '', httpFile: '', file_id: '', flist: [] }
      ],
      fileList1: [
        { origin_name: '', file_name: '', httpFile: '', file_id: '', flist: [] }
      ],
      del_atta_list: [],
      del_atta_list1: [],
      isDisabled: false, // 控制按钮是否禁用  
      countdown: 5, // 倒计时剩余时间  
      buttonWord: '5秒后方可确认', // 倒计时剩余时间  
      intervalId: null,
    }
  },
  created() {
    // console.log(this.$route)
    this.query = this.$route.query
    this.mType = this.query.mType ? this.query.mType : '1'
    this.query.id && this.getDetail(this.query.id)
  },

  watch: {
    ['form.payee_bank_account'](val) {
      if (val != undefined) {
        this.$nextTick(() => {
          this.form.payee_bank_account = val.replace(/\D/g, '').replace(/....(?!$)/g, '$& ');
        });
      }
    },
  },
  methods: {
    checkUrlFn() {
      // 获取当前URL的哈希部分  
      const hash = window.location.hash;  
      // 移除'#'字符  
      const url = hash.substring(1); 
      
      let postData = {
        url_path: url
      }
      api.checkLoginUrl(postData).then((res) => {
        if (res.status == 400) {
          this.$message({
            type: 'info',
            message: '暂无权限',
          })
          this.$router.push({
            path: `/home`
          });
        }
      })
    },
    checkNodeFn(menu_id) {
      let postData = {
        menu_id,
      }
      api.checkNode(postData).then((res) => {
        this.nodeLimtList = res.node_ids.split(',')
      })
    },
    NodeInclude(val) {
      return this.nodeLimtList.includes(val)
    },
    addImage(arr) {
      arr.push({
        origin_name: '', file_name: '', httpFile: '', id: '', flist: []
      });
    },
    removeImage(arr, index) {
      if (arr[index].id) {
        this.del_atta_list.push(arr[index].id);
      }
      console.log(this.del_atta_list);
      arr = arr.splice(index, 1);
    },
    addImage1(arr) {
      arr.push({
        origin_name: '', file_name: '', httpFile: '', id: '', flist: []
      });
    },
    removeImage1(arr, index) {
      if (arr[index].id) {
        this.del_atta_list1.push(arr[index].id);
      }
      console.log(this.del_atta_list1);
      arr = arr.splice(index, 1);
    },
    //选择文件
    uploadFile(file, fileList, ref, item, index) {
      let formData = new FormData();
      formData.append("file_arr", file.raw);
      formData.append("type", 2);
      api.uploadFile(formData)
        .then((res) => {
          this[fileList][index] = {
            ...item,
            origin_name: res.origin_name,
            file_name: res.file_name,
            httpFile: res.httpFile,
          }
          this.$forceUpdate()
          this.$refs[ref][index].clearFiles();
          // this.updateFn()
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getPurchaseNo() {
      if (this.is_apply == 1 || this.is_apply == 3) {
        this.$message.error('该合同暂未提交合同申请')
        return false
      }
      if (this.form.contract_type != '2') {
        if (this.form.payArr.budget_status != '3') {
          this.$message.error(`供应商合同无对应审核通过的预算`)
          return false
        }
        if (antiThousands(this.form.contract_amount) - antiThousands(this.form.payArr.budget) > 0) {
          this.$message.error(`供应商合同金额不能大于对应预算金额`)
          return false
        }
      }
      this.$fly
        .post('apiPurchase_getContractNo.html', {
          contract_id: this.query.id,
          mType: this.mType,
        })
        .then((res) => {
          this.form.contract_no = res.contractNo
          this.$message.success('供应商合同编号获取成功')
          this.canGetNo = false
        })
    },
    getDetail(id) {
      this.checkUrlFn()
      this.checkNodeFn('61')
      return new Promise((resolve, reject) => {
        this.$fly
          .post('apiPurchase_getContractDetail.html', {
            contract_id: id,
          })
          .then((res) => {
            if (res) {
              let form = res.itemArr
              //is_apply
              this.is_apply = form.is_apply
              console.log(this.is_apply);
              this.fileList = res.itemArr.fileList.filter(item => item.file_type == '1').map((item) => {
                delete item.project_id
                delete item.create_time
                item.flist = []
                return item
              })
              this.fileList1 = res.itemArr.fileList.filter(item => item.file_type == '2').map((item) => {
                delete item.project_id
                delete item.create_time
                item.flist = []
                return item
              })
              //防空情况            
              if (this.fileList.length == 0) {
                this.fileList = [{ origin_name: '', file_name: '', httpFile: '', id: '', flist: [] },]
              }
              if (this.fileList1.length == 0) {
                this.fileList1 = [{ origin_name: '', file_name: '', httpFile: '', id: '', flist: [] },]
              }
              console.log(this.fileList, this.fileList1);
              this.canGetNo = (res.itemArr.contract_no == '' || res.itemArr.contract_no == 'TBD') ? true : false
              setTimeout(() => {
                //权限
                this.level = store.state.level
                this.realName = store.state.realName
                return (this.form = form)
              }, 200);
              resolve(res)
            }
            else {
              reject('error')
            }
          })
      })
    },
    updateFn() {
      this.form.contract_id = this.query.id || ''
      this.form.option = this.form.id ? '2' : '1'
      //替换掉id为file_id
      let fileList = this.fileList.map((item) => {
        delete item.flist
        delete item.httpFile
        item.file_type = 1
        return item
      })
      let fileList1 = this.fileList1.map((item) => {
        delete item.flist
        delete item.httpFile
        item.file_type = 2
        return item
      })
      fileList = fileList.concat(fileList1)
      let del_atta_list = this.del_atta_list
      let del_atta_list1 = this.del_atta_list1
      const del_atta = del_atta_list.concat(del_atta_list1)
      const $fileList = fileList.map((item) => {
        Object.keys(item).forEach(key => {
          if (key == 'id') {
            item['file_id'] = item[key]
            console.log(item['file_id']);
            delete item[key]
          }
        })
        return item
      })
      fileList = $fileList
      const tempForm = JSON.parse(JSON.stringify(this.form))
      delete tempForm.is_apply
      delete tempForm.status
      delete tempForm.projectArr
      delete tempForm.fileList
      this.$fly
        .post('apiPurchase_addUpdateContract.html', {
          contract_id: tempForm.id,
          ...tempForm,
          atta_str: JSON.stringify(fileList),
          atta_del: del_atta.toString(),
          mType: this.mType,
        })
        .then((res) => {
          if (res) {
            this.$message.success('供应商合同附件已更新')
          }
          this.query.id && this.getDetail(this.query.id)
        })
    },
    showWrongFn() {
      this.$message.error('请先获取供应商合同编号')
    },
    clickCopy(msg) {
      const save = function (e) {
        e.clipboardData.setData('text/plain', msg.replace(/\s*/g, ""))
        e.preventDefault() // 阻止默认行为
      }
      const once = {
        once: true
      }
      document.addEventListener('copy', save, once) // 添加一个copy事件,当触发时执行一次,执行完删除
      document.execCommand('copy') // 执行copy方法
      this.$message({ message: '复制成功', type: 'success' })
    },
    //合同申请
    contractApply() {
      this.query.id && this.getDetail(this.query.id).then(() => {
        if (!this.fileList[0].origin_name) {
          this.$message.error('请先上传电子合同')
          return false
        }
        if (this.is_apply == 2) {
          this.$message.error('供应商合同申请已提交')
          return false
        }
        if (this.form.contract_no && this.form.contract_no != 'TBD') {
          this.$message.error('供应商合同已立项，不可提交合同申请')
          return false
        }
        if (this.form.contract_type != '2') {
          if (this.form.payArr.budget_status != '3') {
            this.$message.error(`供应商合同无对应审核通过的预算`)
            return false
          }
          if (antiThousands(this.form.contract_amount) - antiThousands(this.form.payArr.budget) > 0) {
            this.$message.error(`供应商合同金额不能大于对应预算金额`)
            return false
          }
        }
        this.conShow = true
        if (!this.isDisabled) {
          this.isDisabled = true; // 禁用按钮  
          this.countdown = 5; // 设置倒计时为5秒  
          // 使用setInterval进行倒计时  
          this.intervalId = setInterval(() => {
            this.countdown--; // 倒计时减一  
            if (this.countdown <= 0) {
              clearInterval(this.intervalId); // 倒计时结束，清除定时器  
              this.isDisabled = false; // 重新启用按钮  
              this.countdown = 0; // 重置倒计时  
              this.buttonWord = `确 定`;
            }
            else {
              this.buttonWord = `${this.countdown}秒后方可确认`;
            }
          }, 1000); // 每秒执行一次  
        } else {
          this.buttonWord = `${this.countdown}秒后方可确认`;
        }
      })
    },
    handleConApplyNo() {
      this.conShow = false
      clearInterval(this.intervalId); // 倒计时结束，清除定时器  
      let tout = setTimeout(() => {
        this.isDisabled = false
        this.countdown = 5
        this.buttonWord = `${this.countdown}秒后方可确认`;
        clearInterval(tout);
      }, 500);
    },
    handleConApply(is_apply) {
      const tempForm = JSON.parse(JSON.stringify(this.form))
      delete tempForm.is_apply
      delete tempForm.status
      delete tempForm.projectArr
      delete tempForm.fileList
      this.$fly
        .post('apiPurchase_addUpdateContract.html', {
          contract_id: tempForm.id,
          ...tempForm,
          option: 2,
          //以上内容必填
          is_apply: is_apply,
          mType: this.mType,
        })
        .then((res) => {
          if (res) {
            this.conShow = false
            if (is_apply == 2) {
              this.$message.success('供应商合同申请已提交')
            }
            else {
              this.$message.success('供应商合同申请已退回')
            }
          }
          this.query.id && this.getDetail(this.query.id)
        })
    },
  },
}
</script>

<style lang="scss" scoped>
.materialwrap {
  .form.myform {
    padding-left: 100px;
  }

  .filterwrap {
    display: flex;
    justify-content: flex-end;
    padding: 0 0 15px 0;

    .el-button {
      margin: 0 0 0 20px;
    }
  }

  .base1 {
    @extend %box;
    margin-bottom: 20px;
    padding: 30px 40px;
    position: relative;

    .ntitle {
      display: inline-block;
      margin: 0 0 25px 0;

      &::before {
        width: 100%;
      }
    }

    ul {
      @extend %start;
      color: #231f20;
      background: #f2f2f2;
      padding: 0 25px;
      border-radius: 20px;
      margin-bottom: 20px;
      position: relative;

      &:last-of-type {
        margin-bottom: 0;
      }

      li {
        width: 50%;
        font: 14px/3 $font;

        p {
          min-height: 42px;
          padding: 5px 0;
          @extend %start;
          position: relative;

          label {
            width: 150px;
            white-space: nowrap;
            flex: none;
          }

          .projectArrBtnArea {
            width: 180px;
            position: absolute;
            left: 60%;
            @extend %start;
            z-index: 1;
            .projectArrBtn {
              margin-right: 20px;
              &:last-of-type {
                margin-right: 0;
              }
            }
          }

          .anlist {
            padding: 0;
            width: 100%;
            flex-flow: column nowrap;

            li {
              position: relative;
              width: 100%;

              .abtn {
                position: absolute;
                top: 50%;
                left: 100%;
                transform: translateY(-50%)
              }
            }
          }

        }
      }
    }
  }
}

.linkwrap {
  font-size: 12px;

  &.normal {
    color: #606266;

    a {
      color: #606266;

      &:hover {
        cursor: pointer !important;

        &::after {
          height: 0.2px;
          background-color: #606266;
        }
      }

      >span {
        font-size: 14px;
        color: #606266;
      }
    }
  }
}

.operater {
  @extend %start;
  position: absolute;
  top: 30px;
  right: 40px;
  font: 14px/1 $font;
  text-align: center;

  >div {
    min-width: 32px;
    border: 1px solid #DCDFE6;
    border-radius: 3px;
    padding: 9px 10px;
    cursor: pointer;

    &.linkline {
      border-color: transparent;
      background: transparent;
      color: #231f20;

      &:hover {
        &::after {
          display: block;
          content: '';
          height: 0.1px;
          background: #231f20;
        }
      }
    }

    &.linkbox {
      border-color: #0E0F22;
      background: #0E0F22;
      color: #fff;

      &.grey {
        border-color: #c0c4cc;
        background: #c0c4cc;
        color: #fff !important;

        &:hover {
          background: #c0c4cc;
        }
      }

      &:hover {
        background: rgba($color: #0E0F22, $alpha: 0.8);
      }
    }
  }
}
</style>
